import { render } from "./callCheckNumModel.vue?vue&type=template&id=63b6afe0"
import script from "./callCheckNumModel.vue?vue&type=script&lang=js"
export * from "./callCheckNumModel.vue?vue&type=script&lang=js"

import "./callCheckNumModel.vue?vue&type=style&index=0&id=63b6afe0&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__